import { Link } from 'react-router-dom';

interface FAQNavbarProps {
  isScrolled: boolean;
}

export default function FAQNavbar({ isScrolled }: FAQNavbarProps): JSX.Element {
  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3 cursor-pointer">
            <span
              className={`text-xl font-light tracking-wider transition-colors ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              <span className="font-bold">P</span>.collective
            </span>
          </Link>

          <div className="flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-gray-900'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              홈
            </Link>
            <Link
              to="/gallery"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-gray-900'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              갤러리
            </Link>
            <a
              href="https://form.naver.com/response/XAc4kYKR-2Wg14KJ-ilzcQ"
              target="_blank"
              rel="noopener noreferrer"
              className={`px-6 py-2.5 border rounded-lg text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white'
                  : 'border-white text-white hover:bg-white hover:text-gray-900'
              }`}
            >
              상담 예약하기
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
